<form>

  <div mat-dialog-content class="getTheme()" style="min-height: 10vh;">
    @if (!isEmpty(data.errors)) {
      <div>
        <p> {{ 'executionEdit.validation.hasErrors' | translate }} </p>
        <ul>
          @for (error of data.errors; track error) {
            <li> {{ error }} </li>
          }
        </ul>
      </div>
    }

    @if (!isEmpty(data.warns)) {
      <div>
        <p> {{ 'executionEdit.validation.hasWarns' | translate }} </p>
        <ul>
          @for (warn of data.warns; track warn) {
            <li> {{ warn }} </li>
          }
        </ul>
        @if (isEmpty(data.errors)) {
          <p> {{ 'generic.clone.hasWarns.noErrors' | translate }} </p>
        }
      </div>
    }

  </div>

  <div mat-dialog-actions class="getTheme()">
    <div fxFlex></div>
    @if (isEmpty(data.errors)) {
      <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>
        {{ 'button.accept' | translate }}
      </button>
    }

    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>